import { useEffect } from 'react';

const PortfolioSEO = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://gwdevelopers.com';

    document.title = 'Nashville Website Design Portfolio | GWDevelopers';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Browse Nashville website design examples for restaurants, home services, retail & more. Fast launch, AI-powered web development in Nashville, TN.'
      );
    }

    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) canonical.href = `${siteUrl}/portfolio`;

    const schemas = [
      {
        id: 'portfolio-webpage-schema',
        data: {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          '@id': `${siteUrl}/portfolio#webpage`,
          url: `${siteUrl}/portfolio`,
          name: 'Nashville Website Design Portfolio — GWDevelopers',
          description:
            'Browse professional website examples and web development services for Nashville, TN small businesses.',
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/#localbusiness` },
          dateModified: '2026-03-17',
          inLanguage: 'en-US',
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: `${siteUrl}/`,
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Portfolio',
                item: `${siteUrl}/portfolio`,
              },
            ],
          },
        },
      },
      {
        id: 'portfolio-collection-schema',
        data: {
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'Nashville Website Design Portfolio — GWDevelopers',
          description:
            'Browse professional website examples and web development services for Nashville, TN small businesses',
          url: `${siteUrl}/portfolio`,
          mainEntity: {
            '@type': 'ItemList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                item: {
                  '@type': 'Product',
                  name: 'Home Services Website — Nashville',
                  description:
                    'Professional website examples for Nashville home service businesses: landscaping, HVAC, plumbing, electrical, cleaning, and more.',
                },
              },
              {
                '@type': 'ListItem',
                position: 2,
                item: {
                  '@type': 'Product',
                  name: 'Professional Services Website — Nashville',
                  description:
                    'Website examples for Nashville accounting firms, law offices, consulting firms, doctors offices, and financial advisors.',
                },
              },
              {
                '@type': 'ListItem',
                position: 3,
                item: {
                  '@type': 'Product',
                  name: 'Restaurant Website — Nashville',
                  description:
                    'Modern restaurant website examples for Nashville food service businesses with menus, galleries, and location info.',
                },
              },
              {
                '@type': 'ListItem',
                position: 4,
                item: {
                  '@type': 'Product',
                  name: 'Health & Wellness Website — Nashville',
                  description:
                    'Nashville health and wellness website examples for chiropractors, massage therapy, yoga studios, and personal trainers.',
                },
              },
            ],
          },
        },
      },
      {
        id: 'portfolio-service-schema',
        data: {
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Website Design & Hosting for Nashville Businesses',
          provider: {
            '@type': 'LocalBusiness',
            name: 'GWDevelopers',
            url: siteUrl,
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'Nashville',
              addressRegion: 'TN',
              addressCountry: 'US',
            },
          },
          serviceType: [
            'AI Web Development Nashville',
            'Website Design Nashville',
            'Website Hosting Nashville',
            'Website Management Nashville',
          ],
          areaServed: [
            { '@type': 'City', name: 'Nashville' },
            { '@type': 'City', name: 'Franklin' },
            { '@type': 'City', name: 'Brentwood' },
            { '@type': 'City', name: 'East Nashville' },
          ],
          url: `${siteUrl}/portfolio`,
        },
      },
    ];

    schemas.forEach(({ id, data }) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
    });

    return () => {
      schemas.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
      document.title = 'Web Development Nashville TN | GWDevelopers AI Web Design';
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute(
          'content',
          'Nashville web development agency using AI to build fast, professional websites for small businesses. Serving Nashville, Franklin, Brentwood & East Nashville. Get a free demo!'
        );
      }
      const can = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (can) can.href = `${siteUrl}/`;
    };
  }, []);

  return null;
};

export default PortfolioSEO;
